import { useEffect, useState } from "react";

/**
 * footer 위 8px + 키보드 열리면 키보드 위 8px 에 토스트를 띄우기 위한 bottomOffset 계산 훅
 * - footerRef, bottomSpace를 이용해 기본 위치 계산
 * - visualViewport로 키보드 높이 감지
 */
export function useToastOffset({ footerRef, bottomSpace, gap = 8 }) {
  const [toastOffset, setToastOffset] = useState(0);

  // 1) 기본값: footer 위 + gap
  useEffect(() => {
    const footerH = footerRef.current?.offsetHeight || bottomSpace || 0;
    setToastOffset(footerH + gap);
  }, [footerRef, bottomSpace, gap]);

  // 2) 키보드 열림/닫힘 감지해서 offset 조정
  useEffect(() => {
    if (typeof window === "undefined" || !window.visualViewport) return;

    const baseHeight = window.innerHeight; // 키보드 없는 기준 높이

    const handleViewportChange = () => {
      const vv = window.visualViewport;
      if (!vv) return;

      // 키보드 높이를 대략적으로 계산
      const keyboardHeight = baseHeight - (vv.height + vv.offsetTop);

      if (keyboardHeight > 80) {
        // 키보드가 어느 정도 올라왔다고 판단 → 키보드 위 + gap
        setToastOffset(keyboardHeight + gap);
      } else {
        // 키보드가 거의 없음 → footer 기준으로 복귀
        const footerH = footerRef.current?.offsetHeight || bottomSpace || 0;
        setToastOffset(footerH + gap);
      }
    };

    window.visualViewport.addEventListener("resize", handleViewportChange);
    window.visualViewport.addEventListener("scroll", handleViewportChange);
    handleViewportChange();

    return () => {
      window.visualViewport.removeEventListener("resize", handleViewportChange);
      window.visualViewport.removeEventListener("scroll", handleViewportChange);
    };
  }, [footerRef, bottomSpace, gap]);

  return toastOffset;
}
